/* eslint-disable react/require-default-props */
import React from 'react';
export function ModalFooter({ children, startActions, showDivider = true, className = '' }) {
    const footerClasses = ['qmb-ui-modal-footer', showDivider ? 'qmb-ui-modal-footer--divider' : '', className]
        .filter(Boolean)
        .join(' ');
    return (React.createElement("footer", { className: footerClasses },
        React.createElement("div", { className: "qmb-ui-modal-footer__content" },
            startActions && React.createElement("div", { className: "qmb-ui-modal-footer__start" }, startActions),
            React.createElement("div", { className: "qmb-ui-modal-footer__actions" }, children))));
}
